import { useState } from "react";

/**
 * Custom hook for fetching sessions information.
 * @returns An object containing the fetched data, loading state, and a function to fetch sessions information.
 */
const useGetSessionsInfo = () => {
    const [data, setData] = useState<any>({});
    const [loading, setLoading] = useState(false);

    const API_URL = process.env.REACT_APP_LIST_SESSIONS || ""
    // const api_key = process.env.REACT_APP_API_KEY || "HTCHL77uXq2c9Fr99TgG211Cu6OL5FsLslnseNUj"
    /**
     * Fetches sessions information using the provided request object.
     * @param requestObject - The request object containing the necessary parameters for fetching sessions information.
     */
    const fetchSessionsInfo = async (requestObject: any) => {
        try {
            setLoading(true);
            const responseFetch = await fetch(API_URL, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                //   "x-api-key": api_key
                },
                body: JSON.stringify(requestObject),
              });
              const response = await responseFetch.json();
            setData(response);
        } catch (error) {
            setData(null);
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    return { data, loading, fetchSessionsInfo };
};

export default useGetSessionsInfo;